import React from 'react';
import { MenuItem, TextField } from '@mui/material';
import i18n from '../../i18n';

export default class EditorSelectField extends React.Component {
    onChange(event) {
        this.props.onChange(event.target.name, event.target.value);
    }

    render() {
        // field, value, cache, onChange
        const permissionsVariables = ["allow_all", "allow_own", "deny"];

        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        let id = this.props.field.id;
        let name = this.props.field.label;
        let value = this.props.value;

        return (
            <TextField
                key={name}
                select
                id={id}
                name={id}
                label={translatedName}
                value={value || ''}
                fullWidth
                onChange={(event) => this.onChange(event)}
            >
                {permissionsVariables.map((item) => (
                    <MenuItem key={item} value={item}>
                        {i18n.t(`permissions.${item}`)}
                    </MenuItem>
                ))}
            </TextField>
        );
    }
}
